import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=c2a846ee&scoped=true&"
import script from "./TemplateItem.vue?vue&type=script&lang=ts&"
export * from "./TemplateItem.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=c2a846ee&lang=scss&scoped=true&"
import style1 from "./TemplateItem.vue?vue&type=style&index=1&id=c2a846ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a846ee",
  null
  
)

export default component.exports